var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"view-ui-button-back button-primary",on:{"click":_vm.Handle_OnClickBack}},[_vm._v("Back")])
}
var staticRenderFns = []

export { render, staticRenderFns }